import { atom } from "recoil";
import { ITexasGrouping, SelectedRowsToDelete } from "../types";

export const addStateTexasGrouping = atom({
  key: "addStateTexasGrouping",
  default: false,
});
export const editStateTexasGrouping = atom({
  key: "editStateTexasGrouping",
  default: false,
});

export const selectedRowsStateTexasGrouping = atom<SelectedRowsToDelete>({
  key: "selectedRowsStateTexasGrouping",
  default: [],
});

export const editRowIdTexasGrouping = atom({
  key: "editRowIdTexasGrouping",
  default: [],
});

export const savingTexasGrouping = atom({
  key: "savingTexasGrouping",
  default: false,
});

export const selectedRowsDomainTexasGroupingToDelete = atom<
  SelectedRowsToDelete | undefined
>({
  key: "selectedRowsTexasGroupingToDelete",
  default: undefined,
});

export const rowForEditTexasGrouping = atom<ITexasGrouping | undefined>({
  key: "rowForEditTexasGrouping",
  default: undefined,
});

export const setFilterTextTexasGrouping = atom({
  key: "setFilterTextTexasGrouping",
  default: "",
});
